import AgeGenderModal from 'shared/components/content_gating/age_gender_modal';
import KmklabsUtil from 'shared/kmklabs_util';

export default class AgeGender {
  constructor(element, currentUser, contentType) {
    this.element = element;
    this.currentUser = currentUser;
    this.contentType = contentType;
  }

  type() {
    return 'complete_profile';
  }

  show() {
    let ageGenderModal = this.createAgeGenderModal();
    ageGenderModal.init();

    this.element.classList.remove('hide');
  }

  createAgeGenderModal(){
    let content = {
      type: this.contentType,
      id: KmklabsUtil.videoId()
    };

    return new AgeGenderModal(this.currentUser, content);
  }
}